import $ from 'jquery'
import Recaptcha from '../../utils/recaptcha'
import ScrollHelper from '../../utils/scroll-helper'
import { SITE_KEY } from '../../constants/recaptcha'

const TOGGLE_ACTIVE_VALUE = 'Ja'
const TOGGLE_INACTIVE_VALUE = 'Nein'
const TIMIMG_ACTIVE_CLASS = 'helpinghands-registration-form__timing--active'
const INVALID_CLASS = 'is-invalid'
const BTN_DISABLED_CLASS = 'btn--outline'

const escapeName = name => {
  return name.replace(/([ #;?%&,.+*~':"!^$[\]()=>|/@])/g, '\\$1')
}

class HelpingHandsRegistrationForm {
  constructor(selector = '.helpinghands-registration-form') {
    this.$form = $('form', selector)
    this.form = this.$form.get(0)

    // Exit if no registration form is present
    if (!this.form) {
      return
    }

    this.inputs = $('input', this.form)
    this.textInputs = $('.form-control', this.form)
    this.checkboxInputs = $('.form-check-input', this.form)

    this.timing = $('.helpinghands-registration-form__timing', this.form)
    this.timingToggle = $('#timing-yes, #timing-no', this.form)
    this.timingInputs = $('.form-control', this.timing)

    this.toggleInputs = $('.toggle-wrapper', this.form)
    this.toggleFeedback = $('.toggles-feedback', this.form)

    this.recaptchaContainer = $('.g-recaptcha', this.form).get(0)
    this.submitButton = $('.form-action .btn', this.form)

    this.recaptchaValid = false

    this.init()
  }

  init() {
    this.initRecaptcha()
    this.listen()
  }

  listen() {
    // listen to form submits
    this.$form.on('submit', event => {
      this.submit(event)
    })

    // Set required states for timing fields
    this.timingInputs.on('blur', () => {
      this.setTimingRequiredState(true)
    })

    // validate on focus out events
    this.textInputs.on('change blur', event => {
      this.showInputsValidationStatus(event.target)
    })

    // validate on click events
    this.checkboxInputs.on('click', event => {
      const checkbox = $(event.target)
      const checkboxGroup = $('input[name=' + escapeName(checkbox.attr('name')) + ']')

      this.showInputsValidationStatus(checkboxGroup)
    })

    // validate toggles on change
    this.toggleInputs.on('input', () => {
      this.showTogglesValidationStatus()
    })

    // Extend & collapse on timing toggle change
    this.timingToggle.on('input', () => {
      const value = this.getToggleValue(this.timingToggle)
      value === TOGGLE_ACTIVE_VALUE ? this.activateTiming() : this.deactivateTiming()
    })

    // make submit button be aware of all inputs
    this.inputs.on('input', () => {
      this.setSubmitButtonState()
    })
  }

  submit(event) {
    event.preventDefault()
    const valid = this.validateForm()

    if (valid) {
      return this.form.submit()
    }

    const inputs = this.textInputs.add(this.checkboxInputs)
    this.showInputsValidationStatus(inputs)
    this.showTogglesValidationStatus()
    this.scrollToFirstInvalidInput()
  }

  scrollToFirstInvalidInput() {
    const el = $('.is-invalid', this.form).first()
    ScrollHelper.scrollToElement(el)
  }

  activateTiming() {
    this.timing.slideDown('fast')
    this.timing.addClass(TIMIMG_ACTIVE_CLASS)
    this.setTimingRequiredState(true)
  }

  deactivateTiming() {
    this.timing.slideUp('fast')
    this.timing.removeClass(TIMIMG_ACTIVE_CLASS)
    this.setTimingRequiredState(false)
  }

  setTimingRequiredState(required) {
    const hasDate = this.timingInputs.toArray().some(input => input.value !== '')

    // Make timing input optional when closed
    // or at least one date is set and update invalid state
    if (!required || hasDate) {
      this.timingInputs.attr('required', false)
      this.showInputsValidationStatus(this.timingInputs)
      return
    }

    this.timingInputs.attr('required', true)
  }

  getToggleValue(inputs) {
    let value = null

    inputs.each((index, trigger) => {
      if ($(trigger).is(':checked') && $(trigger).attr('value') === TOGGLE_ACTIVE_VALUE) {
        value = TOGGLE_ACTIVE_VALUE
      }

      if ($(trigger).is(':checked') && $(trigger).attr('value') === TOGGLE_INACTIVE_VALUE) {
        value = TOGGLE_INACTIVE_VALUE
      }
    })

    return value
  }

  getTogglesValidationStatus() {
    return this.toggleInputs.toArray().some(toggle => {
      const inputs = $('input', toggle)
      return (
        this.getToggleValue(inputs) === TOGGLE_ACTIVE_VALUE ||
        this.getToggleValue(inputs) === TOGGLE_INACTIVE_VALUE
      )
    })
  }

  showTogglesValidationStatus() {
    !this.getTogglesValidationStatus()
      ? this.toggleFeedback.addClass(INVALID_CLASS)
      : this.toggleFeedback.removeClass(INVALID_CLASS)
  }

  getRequiredInputsValidationStatus() {
    const requiredInputs = $('input[required]', this.form).toArray()

    const inputsValid = requiredInputs.every(input => {
      return input.validity.valid
    })

    return inputsValid
  }

  showInputsValidationStatus(inputs) {
    // wrap the inputs as jquery object to handle single & array values
    $(inputs)
      .toArray()
      .forEach(input => {
        !input.validity.valid
          ? $(input).addClass(INVALID_CLASS)
          : $(input).removeClass(INVALID_CLASS)
      })
  }

  validateForm() {
    return (
      this.getRequiredInputsValidationStatus() &&
      (this.isExtendedForm ? this.getTogglesValidationStatus() : true) &&
      this.recaptchaValid
    )
  }

  setSubmitButtonState() {
    !this.validateForm()
      ? this.submitButton.addClass(BTN_DISABLED_CLASS)
      : this.submitButton.removeClass(BTN_DISABLED_CLASS)
  }

  initRecaptcha() {
    Recaptcha.render(
      this.recaptchaContainer,
      SITE_KEY,
      this.recaptchaSuccess.bind(this),
      this.recaptchaExpired.bind(this)
    )
  }

  recaptchaSuccess() {
    this.recaptchaValid = true
    this.setSubmitButtonState()
  }

  recaptchaExpired() {
    this.recaptchaValid = false
    this.setSubmitButtonState()
  }
}

export default HelpingHandsRegistrationForm
